
import getAgent from '@/mixins/getAgent'
export default {
    mixins: [getAgent],
}
